import { RootState } from "@/app/stores"
import { IApiKey, IUpdateApiKey, recreateApiKey, updateApiKey } from "@/shared/api/settings"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchRecreateApiKey = createAsyncThunk<
    IApiKey,
    void,
    { state: RootState }
>(`updateApiKey/fetchRecreateApiKey`, async (_, thunkAPI) => {
    try {
        const response = await recreateApiKey()
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchUpdateApiKey = createAsyncThunk<
    IApiKey,
    IUpdateApiKey,
    { state: RootState }
>(`updateApiKey/fetchUpdateApiKey`, async (data, thunkAPI) => {
    try {
        const response = await updateApiKey(data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})